import React, { Fragment, useEffect, useState } from "react";
import { useRespuesta } from "../../data/RespuestaContext";
import { useProyecto } from "../../data/ProyectoContext";
import {
  Button,
  Card,
  CardContent,
  Grid,
  styled,
  Box,
  Collapse,
  Typography,
} from "@mui/material";
import { useJobContext } from "../../hooks/Jobs";
import { config } from "../../config/configLabels";
import ExpandIcon from "./img/ExpandIcon.svg";
import MarkDownText from "../MarkDownText/MarkDownText";
import MarkDownEditor from "../MarkDownText/MarkDownEditor";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import PropuestaDetalleModal from "./PropuestaDetalleModal";

const PropuestasNuevoABP = ({ itemProyecto, indexPropuesta, color }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { etapa, tipoEstructura } = useJobContext();
  const { setRespuestaData, respuesta } = useRespuesta();
  const { enviarProyectoNuevoABP } = useProyecto();
  const [labels, setLabels] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  

  const [markdown, setMarkdown] = useState("");
  const [editMode, setEditMode] = useState(false);

  const NumberBox = styled(Box)(({ theme }) => ({
    width: theme.spacing(10),
    backgroundColor: color,
    color: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "3rem",
  }));


  useEffect(() => {
    if (editMode) {
      setExpanded(true);
    }
  }, [editMode]);

  useEffect(() => {
    const load = () => {
      const labelsCfg = config[etapa]?.[tipoEstructura] || [];
      setLabels(labelsCfg);
    };
    if (itemProyecto) {
      load();
    }
  }, [itemProyecto, etapa, tipoEstructura]);

  useEffect(() => {
    if (!itemProyecto || labels.length === 0) return;

    if (itemProyecto.textoEditado) {
      setMarkdown(itemProyecto.textoEditado);
      setIsLoading(false);
      return;
    }

    const md = labels
      .map((label) => {
        const valor = itemProyecto[label];
        if (!valor) return "";
        return `${valor}`;
      })
      .filter(Boolean)
      .join("\n\n");

    setMarkdown(md);
    setIsLoading(false);
  }, [itemProyecto, labels]);

  const handleSaveMarkdown = () => {
    if (!respuesta || !respuesta.propuestas) {
      console.log("No hay respuesta o propuestas disponibles");
      return;
    }

    const nuevasPropuestas = [...respuesta.propuestas];
    nuevasPropuestas[indexPropuesta] = {
      ...nuevasPropuestas[indexPropuesta],
      textoEditado: markdown,
    };

    const updatePropuesta = {
      ...respuesta,
      propuestas: nuevasPropuestas,
    };

    setRespuestaData(updatePropuesta);
    setEditMode(false);
  };


  const getPreview = (text, limit = 800) => {
    if (!text) return "";
    if (text.length <= limit) return text;
    return text.slice(0, limit) + "…";
  };

  const handleCancelMarkdown = () => {
    if (itemProyecto.textoEditado) {
      setMarkdown(itemProyecto.textoEditado);
    } else {
      const md = labels
        .map((label) => {
          const valor = itemProyecto[label];
          if (!valor) return "";

          return `${valor}`;
        })
        .filter(Boolean)
        .join("\n\n");
      setMarkdown(md);
    }
    setEditMode(false);
  };

  const handleSelect = (item) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const proyectoSeleccionado ={ ...item,
    textoEditado: item?.textoEditado ?? ""}
    enviarProyectoNuevoABP(proyectoSeleccionado, etapa);
  };

  return (
    <Grid key={indexPropuesta} item xs={12} md={12}>
      {isLoading && <>...cargando</>}
      {!isLoading && (
        <Card
          key={indexPropuesta}
          sx={{
            display: "flex",
            m: 2,
            width: "98%",
            border: 1,
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <NumberBox
            sx={{ fontWeight: "bold", fontSize: "65px", color: "#336B87" }}
          >
            {indexPropuesta + 1}
          </NumberBox>

          <CardContent sx={{ fontFamily: "Montserrat", width: "100%" }}>


            {/* ---- Vista NO editable ---- */}
            {!editMode && (
              <>
                {/* Preview cuando está colapsado */}
                {!expanded && (
                  <Box
                    sx={{
                      mb: 2,
                      "& *": {
                        lineHeight: 0.8,
                      },
                    }}>
                    <MarkDownText
                      data={getPreview(markdown)}
                      img={null}
                    />
                  </Box>
                )}

                {/* Collapse */}
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <Box sx={{ mb: 2 }}>
                    <MarkDownText data={markdown} img={null} />
                  </Box>
                  <Button
                    variant="outlined"
                    sx={{
                      borderRadius: "20px",
                      borderColor: "#336B87",
                      color: "#336B87",
                      mr: 1,
                    }}
                    startIcon={
                      <img
                        src={ExpandIcon}
                        alt="Icono"
                        style={{ width: "20px", height: "20px" }}
                      />
                    }
                    onClick={() => setEditMode(true)}
                  >
                    Editar propuesta
                  </Button>
                </Collapse>
              </>
            )}

            {/* Vista editable */}
            {editMode && (
              <>
                <MarkDownEditor data={markdown} setEditedValue={setMarkdown} />
                <Box
                  m={2}
                  display="flex"
                  width="100%"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    onClick={handleSaveMarkdown}
                    sx={{
                      borderRadius: 5,
                      fontFamily: "Montserrat",
                      fontWeight: 700,
                      textTransform: "none",
                      bgcolor: "#336B87",
                      color: "#fff",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#1FC16B",
                        boxShadow: "none",
                      },
                    }}
                  >
                    Guardar
                  </Button>
                  <Button
                    sx={{
                      ml: 2,
                      borderRadius: 5,
                      fontFamily: "Montserrat",
                      fontWeight: 700,
                      textTransform: "none",
                      bgcolor: "#336B87",
                      color: "#fff",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#ff0000ff",
                        boxShadow: "none",
                      },
                    }}
                    onClick={handleCancelMarkdown}
                  >
                    Cancelar
                  </Button>
                </Box>
              </>
            )}

            {/* Fila con Ver más/menos centrado y Seleccionar a la derecha */}
            <Box
              sx={{
                mt: 3,
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              {!editMode && (
                <>
                  {/* Ver más / Ver menos centrado */}
                  <Box
                    onClick={() => setExpanded((prev) => !prev)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setExpanded((prev) => !prev);
                      }
                    }}
                    sx={{
                      position: "absolute",
                      left: "50%",
                      mb: 2,
                      transform: "translateX(-50%)",
                      display: "inline-flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      userSelect: "none",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",

                      "&:hover": {
                        transform: "translateX(-50%) translateY(-1px)",
                      },

                      "@keyframes floatArrow": {
                        "0%": { transform: "translateY(0)" },
                        "50%": { transform: "translateY(-4px)" },
                        "100%": { transform: "translateY(0)" },
                      },

                      "&:hover .label::after": {
                        width: "80%",
                      },
                    }}
                  >
                    <Box
                      className="arrow-wrapper"
                      sx={{
                        lineHeight: 1,
                        animation: "floatArrow 0.8s ease-in-out infinite",
                      }}
                    >
                      <ExpandMoreRoundedIcon
                        sx={{
                          fontSize: 50,
                          color: "#336B87",
                          transition: "transform 0.25s ease",
                          transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                      />
                    </Box>

                    {/* Texto Ver más / Ver menos */}
                    <Typography
                      className="label"
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: 12,
                        fontWeight: 700,
                        color: "#336B87",
                        letterSpacing: "0.04em",
                        textTransform: "uppercase",
                        position: "relative",
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          left: "50%",
                          bottom: -2,
                          width: "0%",
                          height: 2,
                          borderRadius: 999,
                          backgroundColor: "#336B87",
                          transform: "translateX(-50%)",
                          transition: "width 0.25s ease",
                        },
                      }}
                    >
                      {expanded ? "Ver menos" : "Ver más"}
                    </Typography>
                  </Box>

                  {/* Botón seleccionar alineado a la derecha */}
                  <Box sx={{ ml: "auto", display: "flex", gap: 1.5 }}>
                     <Button
                      variant="outlined"
                      sx={{
                        borderRadius: 5,
                        borderColor: "#336B87",
                        color: "#336B87",
                        fontFamily: "Montserrat",
                        textTransform: "none",
                        fontSize: 13,
                        "&:hover": {
                          borderColor: "#336B87",
                          backgroundColor: "rgba(51,107,135,0.06)",
                        },
                      }}
                      onClick={() => setIsModalOpen(true)}
                    >
                      Ver detalle
                    </Button>
                   <Button
                      variant="contained"
                      color="success"
                      sx={{
                        pl: "10px",
                        pr: "10px",
                        borderRadius: 5,
                        backgroundColor: "#336B87",
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "#336B82",
                          boxShadow: "none",
                        },
                      }}
                      onClick={() => handleSelect(itemProyecto)}
                      data-amplify-analytics-on="click"
                      data-amplify-analytics-name={`click-on-seleccionarPropuesta`}
                      data-amplify-analytics-attrs={`onClick:handleSelect etapa=${etapa}, tipoEstructura:${tipoEstructura}`}
                    >
                      Seleccionar
                    </Button>
                  </Box>
                </>
              )}
            </Box>

             <PropuestaDetalleModal
              open={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              markdown={markdown}
              labels={labels}
              itemProyecto={itemProyecto}
              color={color}
              titulo={`Propuesta ${indexPropuesta + 1}`}
            />

          </CardContent>
        </Card>
      )}
    </Grid>
  );
};

export default PropuestasNuevoABP;
